import React from "react";
import { Wallet, FileCheck2, HandCoins } from "lucide-react";
import { TABBY_LOGO, TAMARA_LOGO } from "@/lib/constants";

const STEPS = [
  {
    num: "01",
    icon: Wallet,
    title: "اختر المبلغ المناسب لك",
    desc: "حدد المبلغ الذي تحتاجه من 1,000 ريال وحتى 25,000 ريال بكل سهولة.",
  },
  {
    num: "02",
    icon: FileCheck2,
    title: "نجهز الطلب عبر تابي أو تمارا",
    desc: "نتولى كافة الإجراءات نيابةً عنك بسرعة ودقة واحترافية تامة.",
    withLogos: true,
  },
  {
    num: "03",
    icon: HandCoins,
    title: "تستلم السيولة فورًا",
    desc: "يتم تحويل المبلغ إلى حسابك خلال دقائق بدون تعقيد أو انتظار.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="py-20 md:py-28 bg-brand-bg" data-testid="how-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-14 fade-up">
          <div className="inline-block text-brand-gold font-bold text-sm tracking-widest uppercase mb-3">
            الخطوات
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-brand-green leading-tight">
            كيف نوفر لك السيولة؟
          </h2>
          <p className="mt-3 text-base md:text-lg text-brand-ink/70 max-w-2xl mx-auto">
            إجراءات سريعة بدون تعقيد أو انتظار طويل — فقط ثلاث خطوات بسيطة تفصلك عن سيولتك.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {STEPS.map((s, i) => (
            <div
              key={i}
              className="group relative bg-white rounded-3xl p-7 md:p-8 border border-black/5 shadow-[0_4px_30px_-10px_rgba(15,61,46,0.08)] hover:shadow-[0_20px_50px_-20px_rgba(15,61,46,0.25)] hover:-translate-y-1 transition-all duration-300 fade-up"
              style={{ animationDelay: `${i * 0.12}s` }}
              data-testid={`step-card-${i + 1}`}
            >
              {/* Step number */}
              <div className="absolute -top-5 end-6 font-heading text-5xl font-black text-gold-gradient opacity-80">
                {s.num}
              </div>

              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-green to-brand-green-light flex items-center justify-center mb-5 shadow-lg">
                <s.icon className="w-7 h-7 text-brand-gold" />
              </div>

              <h3 className="font-heading text-xl md:text-2xl font-extrabold text-brand-green mb-2 leading-tight">
                {s.title}
              </h3>
              <p className="text-brand-ink/70 leading-relaxed text-sm md:text-base">
                {s.desc}
              </p>

              {s.withLogos && (
                <div className="mt-5 flex items-center gap-3 pt-5 border-t border-dashed border-brand-gold/30">
                  <img
                    src={TABBY_LOGO}
                    alt="tabby"
                    className="h-10 w-auto rounded-lg shadow-sm"
                    loading="lazy"
                    data-testid="tabby-logo"
                  />
                  <img
                    src={TAMARA_LOGO}
                    alt="tamara"
                    className="h-10 w-auto rounded-lg shadow-sm"
                    loading="lazy"
                    data-testid="tamara-logo"
                  />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-white border border-brand-gold/40 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-brand-gold animate-pulse" />
            <span className="text-sm font-bold text-brand-green">
              إجراءات سريعة بدون تعقيد أو انتظار طويل
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
